'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index = require('../../../node_modules/prop-types/index.js');

var index$1 = require('../../../node_modules/classnames/index.js');

require('../../../primitives/Button/Button.js');

require('../../../primitives/Hero/Hero.js');

var Icon = require('../../../primitives/Icon/Icon.js');

require('../../../primitives/Link/Link.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var SideNavDropdownMenu = function SideNavDropdownMenu(_ref) {
  var className = _ref.className,
      title = _ref.title,
      children = _ref.children,
      active = _ref.active,
      searchActive = _ref.searchActive;

  var _useState = React.useState(active),
      _useState2 = slicedToArray['default'](_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var menuOpen = isOpen || searchActive;
  var classes = index$1['default']('lanl-side-nav-dropdown-menu', className);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    onClick: function onClick(e) {
      e.stopPropagation();
      setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: menuOpen ? 'open' : ''
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "title-container"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "title"
  }, title), /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
    icon: "chevron-down",
    size: "sm",
    className: "chevron"
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "content"
  }, children)));
};

SideNavDropdownMenu.defaultProps = {
  searchActive: false
};
SideNavDropdownMenu.propTypes = {
  active: index['default'].bool,
  children: index['default'].node,
  className: index['default'].string,
  searchActive: index['default'].bool,
  title: index['default'].string
};
exports.SideNavDropdownMenu = SideNavDropdownMenu;
exports['default'] = SideNavDropdownMenu;